import { Box, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"

export function PdfTimingTaskList({ items, color = "#111827" }) {
    return (
        <Box>
            <Repeat list={items} item={<PdfTimingTaskListItem color={color} />} />
        </Box>
    )
}

function PdfTimingTaskListItem({ item, color }) {
    return <Typography sx={{ fontSize: "10px", color, mb: "2px" }}>{item.label}</Typography>
}
